import { useState } from 'react';
import { Tooltip } from '@odo/shared-ui';
import { useIsTextTruncated } from '../../hooks/useIsTextTruncated';

interface TruncatedLabelProps {
    text: string;
    className?: string;
    side?: 'top' | 'right' | 'bottom' | 'left';
}

// One-line label that shows its full text on hover, only when it is actually cropped.
export function TruncatedLabel({ text, className = '', side = 'top' }: TruncatedLabelProps) {
    const [element, setElement] = useState<HTMLSpanElement | null>(null);
    const truncated = useIsTextTruncated(element, text);
    return (
        <Tooltip content={text} side={side} disabled={!truncated}>
            <span ref={setElement} className={`truncate ${className}`}>
                {text}
            </span>
        </Tooltip>
    );
}
